module.exports = __webpack_public_path__ + "img/react.68c634e5.svg";